Vue.component('cookiebot-declaration-component', {
    name: 'CookiebotDeclaration',
    props:{
        domainId: {
            type: String,
            required: true
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            if(this.domainId){
                // Load external js
                const script = document.createElement('script');
                script.src = 'https://consent.cookiebot.com/' + this.domainId + '/cd.js';
                document.getElementById('app').appendChild(script);

                this.$root.cookiebotDeclarationLoaded = true;
            }
        }
    }
});
